import s from "./radioInput.module.css";
import {useAppContext} from "../../../../../../contexts";

const RadioInput = (props) => {
    // Destructured props
    const {
        rating,
        formValues,
        handleChange,
        handleMouseEvent
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Checks whether the current input is checked or not
    const isChecked = formValues.fsRating === rating;

    return (
        <fieldset className={s.fieldset}>
            <input
                type="radio"
                name={"fsRating"}
                id={`fsRating-input-${rating}`}
                value={rating}
                checked={isChecked}
                className={"hidden"}
                onInput={e => handleChange(e)}
            />
            <label
                for={`fsRating-input-${rating}`}
                className={`${s.ratingLabel} ${highContrast ? "text-[#fecc31]" : "text-[#C50C0F]"} ${isChecked ? "font-bold" : "font-normal"}`}
                onMouseEnter={() => handleMouseEvent({
                    action: "ENTER",
                    value: rating
                })}
                onMouseLeave={() => handleMouseEvent({
                    action: "LEAVE",
                    value: rating
                })}
            >
                {rating}
            </label>
        </fieldset>
    )
}

export default RadioInput;
